import { useTranslation } from "react-i18next"

export function ApplicationErrorPage({
    error,
}: {
    error: Error
}) {
    const { t } =
        useTranslation()
    return (
        <main className="flex min-h-screen items-center justify-center p-6">
            <div className="max-w-lg rounded-lg border border-(--color-border) bg-(--color-surface) p-6">
                <h1 className="text-xl font-bold">
                    {t('titles.applicationError')}
                </h1>

                <p className="mt-3 text-(--color-danger)">
                    {error.message}
                </p>
            </div>
        </main>
    )
}